import { useCallback, useState } from 'react';
import { MediaState } from '../domain/media-file.types';
import { mediaReducer } from '../reducer/media.reducer';
import { MediaEvent } from '../media.events';

export const useMediaState = (initialFiles: MediaState) => {
  const [files, setFiles] = useState<MediaState>(initialFiles);

  const applyEvent = useCallback((event: MediaEvent) => {
    setFiles((prev) => mediaReducer(prev, event));
  }, []);

  return { files, applyEvent, setFiles };
};
